import { combineSlices, configureStore } from '@reduxjs/toolkit';
import { authSlice } from '@features/auth';
import { receiptsSlice } from '@features/receipts';

/**
 * Racine du store Redux.
 *
 * Les slices des features sont composés ici, dans la racine de composition
 * (le sens de dépendance autorisé est app → features, jamais l'inverse).
 *
 * `combineSlices` permettra demain l'injection paresseuse de reducers
 * (`rootReducer.inject(slice)`), prérequis pour des features chargées
 * dynamiquement dans une architecture microfrontend.
 */
export const rootReducer = combineSlices(authSlice, receiptsSlice);

export type RootState = ReturnType<typeof rootReducer>;

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
}

export const store = setupStore();

export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
